import createReactComponent from '../createReactComponent';
export default createReactComponent('code-circle-2', 'IconCodeCircle2', [
  ['path', { d: 'M8.5 13.5l-1.5 -1.5l1.5 -1.5', key: 'svg-0' }],
  ['path', { d: 'M15.5 10.5l1.5 1.5l-1.5 1.5', key: 'svg-1' }],
  ['path', { d: 'M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0', key: 'svg-2' }],
  ['path', { d: 'M13 9.5l-2 5.5', key: 'svg-3' }],
]);
